/* eslint-disable @typescript-eslint/no-explicit-any */
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const Icon: any = styled(Box)({
  '& svg': {
    fontSize: '7em',
    marginTop: 0,
    color: 'rgba(0,0,0, 0.1)',
    position: 'absolute',
    left: '9%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

export const StyledTitle: any = styled(Typography)(() => ({
  marginBottom: '10px',
  marginTop: '15px',
  fontSize: '1.2em',
}));

export const StyledDescription: any = styled(Typography)(() => ({
  fontSize: '14px',
  fontStyle: 'italic',
  zIndex: 1,
  position: 'relative',
}));

export const StyledBox: any = styled(Box)(({ theme }) => ({
  fontFamily: '"Arial", sans-serif',
  background: '#f1f7f7',
  borderRadius: '15px',
  padding: '15px',
  border: `1px solid ${theme.palette.divider}`,
  '& *': {
    color: '#666',
  },
}));
